// extracted by mini-css-extract-plugin
export var active = "_c5-c";
export var compactArrow = "_c5-5";
export var container = "_c5-0";
export var dot = "_c5-b";
export var dotContainer = "_c5-a";
export var hoverArrowButton = "_c5-7";
export var hoverArrowContainer = "_c5-6";
export var leftHoverArrowContainer = "_c5-8 _c5-6";
export var rightHoverArrowContainer = "_c5-9 _c5-6";
export var slide = "_c5-4";
export var sliderContainer = "_c5-1";
export var sliderContainerVisibleOverflow = "_c5-2";
export var sliderOverflow = "_c5-3";
export var vignetteBoth = "_c5-f";
export var vignetteLeft = "_c5-e";
export var vignetteRight = "_c5-d";